/**
 * @PLATFORM_CODE
 * @readonly
 * @enum {number}
 * @type {{Wx: string, WxMpg: string, QyWx: string}}
 */
export const PLATFORM_CODE = {
    //微信
    Wx: "Wx",
    //微信小程序
    WxMpg: "WxMpg",
    //企业微信
    QyWx: "QyWx",
};
